export const siteInfo = {
  name: "吃瓜复盘局",
  slogan: "网红事件完整经过 · 深度解析 · 前因后果一次说清",
  shortDesc: "把热搜里的碎片信息，整理成有时间线、有争议焦点、有深度解析的完整复盘。",
  intro:
    "吃瓜复盘局是一个专注网红事件完整经过的中文内容站点。我们不做标题党式的情绪输出，而是按时间顺序还原事件全貌，交叉核对各方公开表态，把起因、发酵、高潮与后续影响拆开讲清楚，让你看完一篇就能自己下判断。",
  email: "hello@chiguafupan.com",
  domain: "https://rbnetwork.cn",
  foundedYear: "2022",
  updateFrequency: "每日更新 3 次",
};

export const navLinks = [
  { label: "首页", href: "/" },
  { label: "事件库", href: "/events" },
  { label: "常见问题", href: "/faq" },
  { label: "关于我们", href: "/about" },
];

export const categories = [
  {
    slug: "ecommerce",
    name: "带货翻车",
    icon: "ri-shopping-bag-3-line",
    desc: "选品争议、虚假宣传、退货潮与售后纠纷的完整经过",
    count: 92,
  },
  {
    slug: "emotion",
    name: "情感纠纷",
    icon: "ri-heart-3-line",
    desc: "录音、聊天记录与多方说法交织的舆论拉锯战",
    count: 68,
  },
  {
    slug: "persona",
    name: "人设争议",
    icon: "ri-user-star-line",
    desc: "学历、身份、经历被质疑后人设如何一步步松动",
    count: 74,
  },
  {
    slug: "copyright",
    name: "版权抄袭",
    icon: "ri-copyright-line",
    desc: "洗稿、搬运与原创作者维权的漫长过程记录",
    count: 45,
  },
  {
    slug: "livestream",
    name: "直播风波",
    icon: "ri-live-line",
    desc: "直播失言、突发状况与舆情发酵的 48 小时复盘",
    count: 63,
  },
  {
    slug: "industry",
    name: "行业观察",
    icon: "ri-bar-chart-box-line",
    desc: "合约纠纷、MCN 机构与创作者生态背后的结构性问题",
    count: 38,
  },
];

export const processSteps = [
  {
    step: "01",
    title: "还原完整经过",
    icon: "ri-timeline-view",
    desc: "按时间顺序标注每一个关键节点，保留原文与公开截图，不跳过对判断有影响的一步。",
  },
  {
    step: "02",
    title: "梳理关键信息",
    icon: "ri-node-tree",
    desc: "把当事人、品牌方、平台、监管方的公开动作分开列出，谁在什么时候做了什么一目了然。",
  },
  {
    step: "03",
    title: "提炼争议焦点",
    icon: "ri-focus-3-line",
    desc: "把舆论里吵得最凶的问题拆成独立条目，明确哪些是事实、哪些只是猜测。",
  },
  {
    step: "04",
    title: "分析前因后果",
    icon: "ri-flow-chart",
    desc: "追问事件为什么会发生、舆情靠什么被放大，以及它给同类事件留下了什么参考。",
  },
];

export const stats = [
  { value: "386", suffix: "篇", label: "收录事件复盘" },
  { value: "4200", suffix: "字", label: "平均单篇篇幅" },
  { value: "3", suffix: "次/天", label: "内容更新频率" },
  { value: "12", suffix: "个", label: "长期跟踪栏目" },
];

export const testimonials = [
  {
    name: "小北",
    role: "互联网从业者",
    initial: "北",
    content:
      "热搜每天刷到一堆碎片，真正能把时间线讲明白的没几个。你们的复盘我会收藏，回头再看一遍细节都还对得上。",
    rating: 5,
  },
  {
    name: "阿哲",
    role: "自媒体运营",
    initial: "哲",
    content:
      "写稿前会先来你们这儿对一遍事件节点，省了很多翻旧料的时间，而且标注了信源，引用起来很放心。",
    rating: 5,
  },
  {
    name: "栗子",
    role: "大学生",
    initial: "栗",
    content:
      "最喜欢争议焦点那部分，不站队也不带节奏，就是把双方的说法摆出来让我自己判断，看完不容易被带跑偏。",
    rating: 4,
  },
  {
    name: "老周",
    role: "品牌公关",
    initial: "周",
    content:
      "从行业视角看，你们的发酵机制分析挺有参考价值，尤其适合给团队当反面案例来复盘。",
    rating: 5,
  },
];

export const faqs = [
  {
    q: "网红事件一般多久会平息？",
    a: "没有固定答案，但多数事件的热度曲线符合「三天发酵、一周回落」的规律。真正决定平息速度的往往不是事件的严重程度，而是是否出现新的关键信息、当事方是否给出明确回应。如果回应含糊、反复改口，热度反而会被延长。",
  },
  {
    q: "你们的复盘信息主要来自哪里？",
    a: "优先采用当事方本人、品牌官方账号与平台公告的第一手公开内容，其次是主流媒体的报道。所有关键结论都会标注信息来自哪一方，遇到只有单方说法的内容，我们会明确写成「截至目前仅有一方表态」。",
  },
  {
    q: "同一个事件为什么会有多个版本？",
    a: "因为事件信息是分批释放的。最早流出的往往只是截图或片段，随后才出现完整录音、后台数据或官方说明。我们的做法是保留版本演进的过程，标出每个节点上信息是如何变化的，而不是只给一个最终结论。",
  },
  {
    q: "怎么看待事件里的反转？",
    a: "很多所谓反转，其实是早期信息不完整导致的认知偏差，而不是真的出现了颠覆性证据。复盘时会区分「新证据带来的反转」和「情绪推动的立场变化」，后者并不改变事实本身。",
  },
  {
    q: "你们的内容多久更新一次？",
    a: "日常每天更新三次左右，重点事件会开启持续跟踪，在原文基础上补充最新节点并标注更新时间。已经平息的旧事件如果出现后续进展，我们也会回到原文补充，而不是另开一篇。",
  },
  {
    q: "可以投稿或者提供线索吗？",
    a: "可以。欢迎通过页脚的订阅入口留下联系方式，或发送邮件到我们的公开邮箱。对于涉及隐私的材料，请在提供前先做必要处理，我们不会公开任何未经核实的个人隐私信息。",
  },
  {
    q: "你们在事件中有没有立场？",
    a: "在事实层面我们尽量保持中立，把各方说法并列呈现；在价值层面我们反对网暴、反对未经核实的指控、反对人肉搜索。这个底线是公开写在内容原则里的，也适用于我们自己。",
  },
  {
    q: "复盘会不会涉及当事人的隐私？",
    a: "不会。我们只使用当事人主动公开或媒体已公开的信息，涉及住址、证件号、家庭成员、私密聊天等内容的，一律做脱敏或直接不采用，即使这些内容已经在网上流传。",
  },
  {
    q: "如果发现内容有错误怎么办？",
    a: "请通过邮件指出具体段落与依据，我们核实后会在原文显著位置标注更正说明，并保留更正记录，而不是悄悄删改。内容的可追溯性对我们很重要。",
  },
  {
    q: "普通网友应该怎么看待网红事件？",
    a: "建议按三步走：先看时间线确认信息顺序，再看争议焦点区分事实与猜测，最后再决定要不要表态。在这之前，转发和评论都可以先缓一缓，这既是对当事人负责，也是对自己的判断力负责。",
  },
];

export const aboutPrinciples = [
  {
    icon: "ri-time-line",
    title: "时间线优先",
    desc: "先还原顺序，再谈对错。信息出现的先后，往往比信息本身更能说明问题。",
  },
  {
    icon: "ri-links-line",
    title: "多方信源交叉",
    desc: "任何单一信源都不足以支撑结论，至少两个独立来源互相印证后我们才会写进正文。",
  },
  {
    icon: "ri-scales-3-line",
    title: "区分事实与观点",
    desc: "事实直接陈述，观点明确标注来源。评论区的情绪不等于事件本身。",
  },
  {
    icon: "ri-shield-check-line",
    title: "不站队不煽动",
    desc: "我们不做道德审判，也不用情绪化标题换取流量，把判断留给读者。",
  },
  {
    icon: "ri-question-mark",
    title: "标注不确定信息",
    desc: "还没被证实的内容就明确写「暂未证实」，宁可留白，也不补脑补细节。",
  },
  {
    icon: "ri-edit-2-line",
    title: "及时更正",
    desc: "发现错误会公开更正并保留记录，删改不是处理错误的方式。",
  },
];

export const aboutMilestones = [
  {
    year: "2022",
    title: "从个人博客起步",
    desc: "最初只是把追过的事件按时间顺序记下来，方便自己回头查，没想到慢慢有人来催更。",
  },
  {
    year: "2023",
    title: "沉淀出复盘模板",
    desc: "把「完整经过、关键信息、争议焦点、前因后果」固定成四步结构，让每篇复盘都有稳定的阅读路径。",
  },
  {
    year: "2024",
    title: "搭建事件库与分类",
    desc: "事件开始按带货翻车、情感纠纷、人设争议等方向归类，读者可以按主题回溯同类案例。",
  },
  {
    year: "2025",
    title: "公开复盘方法",
    desc: "把选题标准与核查流程写进关于我们页面，接受读者对照监督。",
  },
];